import React, { Fragment } from "react";

export const RouteManualText = (
    <Fragment>
        Je kan de route uittekenen door met de linkermuisknop punten te plaatsen op de kaart.
        <br />Je kan een punt steeds verleggen/verlengen door met de cursor op dit punt te blijven hangen zodat er een wijsvinger verschijnt.
        <br />Maak je de route langer, dan zal je zien dat er extra punten verschijnen. Deze kan je weer opnieuw verleggen en/of verlengen. Zo kan je steeds je route aanpassen.
        <br />Je kan een punt verwijderen met je rechtermuisknop.
    </Fragment>
);

export const BevoorradingsManualText = (
    <Fragment>
        Om een bevoorradingszone toe te voegen klik je eerst op de blauwe knop &apos;bevoorradingszones toevoegen/wijzigen&apos;.
        <br />Zoom in naar de locatie waar je de bevoorradingszone wilt aanduiden.
        <br />Door te klikken op de linker muisknop plaats je een punt op de kaart.
        <br />Door het laatste punt met het eerste te verbinden teken je een zone in.
        <br />Op het moment dat de punten met elkaar zijn verbonden krijgt de bevoorradingszone een blauwe kleur.
        <br />Bevestig steeds de getekende bevoorradingszones.
        <br />Om de bevoorradingszone te verwijderen klik je eerst op de blauwe knop &apos;bevoorradingszones verwijderen&apos;.
        <br />Plaats je de cursor in de bevoorradingszone en klik je op de linkermuisknop. Bevestig steeds de wijziging in bevoorradingszone.
    </Fragment>
);

export const LusReadOnlyManualText = (
    <Fragment>
        De handleiding ivm het bewerken van de route of de bevoorradingszones kan je terugvinden wanneer je klikt op de knop &apos;bevoorradingszones toevoegen/wijzigen/verwijderen&apos; of &apos;wijzig route op kaart&apos;.
    </Fragment>
);

export const StartplaatsManualText = (
    <Fragment>
        Je kan de blauwe marker verslepen om de exacte locatie van het startpunt aan te duiden
    </Fragment>
);
